module.exports = __webpack_public_path__ + "static/media/reload.48c3c4f9.svg";